import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { createChecklist } from "../../../services/api/qa/checklistService";
import { fetchProjectsApi } from "../../../services/api/boq/projectService";

function ChecklistForm({ onClose }) {
  const navigate = useNavigate();

  const [name, setName] = useState("");
  const [projectId, setProjectId] = useState("");
  const [description, setDescription] = useState("");
  const [projects, setProjects] = useState([]);

  const [loading, setLoading] = useState(false);
  const [errors, setErrors] = useState({});

  // 🔹 Fetch Projects
  useEffect(() => {
    const loadProjects = async () => {
      try {
        const res = await fetchProjectsApi();
        setProjects(res?.data?.data?.data || []);
      } catch (err) {
        console.error("Failed to load projects", err);
      }
    };
    loadProjects();
  }, []);

  // 🔹 Validation
  const validateForm = () => {
    let newErrors = {};

    if (!name.trim()) {
      newErrors.name = "Checklist name is required";
    }

    if (!projectId) {
      newErrors.projectId = "Project is required";
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  // 🔹 Submit
  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!validateForm()) return;

    setLoading(true);

    try {
      const res = await createChecklist({
        name,
        project_id: projectId,
        expected_value:description,
      });

      const checklistId =
        res?.data?.data?.id || res?.data?.id;

      // Redirect to items page
      navigate(`/checklists/${checklistId}/items`);

    } catch (err) {
      console.error(err);
      setErrors({
        api: "Failed to create checklist. Try again.",
      });
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="fixed inset-0 bg-black bg-opacity-30 flex justify-center items-center z-50">
      <div className="bg-white p-6 rounded w-[450px] shadow-lg">
        <h3 className="text-lg font-semibold mb-4">
          Create Checklist
        </h3>

        {errors.api && (
          <p className="text-red-600 text-sm mb-3">
            {errors.api}
          </p>
        )}

        <form onSubmit={handleSubmit}>
          {/* Checklist Name */}
          <input
            type="text"
            placeholder="Checklist Name"
            className="border w-full p-2 mb-1 rounded"
            value={name}
            onChange={(e) => setName(e.target.value)}
          />
          {errors.name && (
            <p className="text-red-500 text-sm mb-2">
              {errors.name}
            </p>
          )}

          {/* Project */}
          <select
            className="border w-full p-2 mb-1 rounded"
            value={projectId}
            onChange={(e) => setProjectId(e.target.value)}
          >
            <option value="">Select Project</option>
            {projects.map((project) => (
              <option key={project.id} value={project.id}>
                {project.project_name}
              </option>
            ))}
          </select>
          {errors.projectId && (
            <p className="text-red-500 text-sm mb-2">
              {errors.projectId}
            </p>
          )}

          {/* Description */}
          <textarea
            placeholder="Description (Optional)"
            className="border w-full p-2 mb-3 rounded"
            value={description}
            onChange={(e) => setDescription(e.target.value)}
          />

          <div className="flex justify-end gap-2">
            <button
              type="button"
              onClick={onClose}
              className="px-3 py-1 border rounded"
              disabled={loading}
            >
              Cancel
            </button>

            <button
              type="submit"
              className="px-4 py-1 bg-blue-600 text-white rounded"
              disabled={loading}
            >
              {loading ? "Saving..." : "Create & Add Items"}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}

export default ChecklistForm;